import { ValidatedResponse } from '@/interfaces/app/ValueObjects'
import { getNestedValue } from '@/util/helpers'

export const AREA_TYPE_MAP: { [areaType: string]: string } = {
  Radius500: 'Okruh 0,5km',
  Radius500_extended: 'Okruh 0,5km',
  Radius1000: 'Okruh 1km',
  Radius1000_extended: 'Okruh 1km',
  Tan1500_3000: 'Tangenciální okolí - užší',
  Tan1500_3000_extended: 'Tangenciální okolí - užší',
  Tan3000_6000: 'Tangenciální okolí - širší',
  Tan3000_6000_extended: 'Tangenciální okolí - širší',
  Extension: 'Dynamické rozšíření venkov',
  Extension_extended: 'Dynamické rozšíření venkov',
}

export function areaTypeDisplayName(
  areaType: string
): ValidatedResponse<string> {
  if (getNestedValue(AREA_TYPE_MAP, [areaType], false)) {
    return {
      valid: true,
      value: AREA_TYPE_MAP[areaType],
    }
  }
  return {
    valid: false,
  }
}
